import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'syf-component-library/ui/atoms/Button';
import { Inline } from 'syf-component-library/ui/spacing';
import { DATA_ANALYTICS, DATA_REASON, DATA_TYPE } from '../../../const/analytics';
import { FAL_TRASH_ALT } from '../../../const/iconProps';
import { colors } from '../../../defaultTheme';
import { t } from '../../../strings/i18n';
const RemoveButton = styled(Button) `
  color: ${(prop) => prop.expandedId === prop.paymentMethodId
    ? colors.darkGrey
    : colors.deleteRedHover};
`;
const PaymentMethodRemoveButton = ({ accountName, className, expandedId, paymentMethodId, buttonRefs, onClick }) => {
    const assignRef = (id, el) => {
        if (buttonRefs) {
            // eslint-disable-next-line no-param-reassign
            buttonRefs.current = Object.assign(Object.assign({}, buttonRefs.current), { [`remove-${id}`]: el });
        }
    };
    return (_jsxs(RemoveButton, Object.assign({ buttonType: "text", className: className, "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-reason": `${DATA_REASON.MANAGE_PAYMENT_METHODS.REMOVE_PAYMENT_METHOD_REMOVE}${accountName}`, "data-type": DATA_TYPE.MAKE_A_PAYMENT, dataCy: "payment-method-remove-button", disabled: expandedId === paymentMethodId, expandedId: expandedId, paymentMethodId: paymentMethodId, ref: (el) => assignRef(paymentMethodId, el), onClick: onClick }, { children: [_jsx(FontAwesomeIcon, { "aria-hidden": true, icon: FAL_TRASH_ALT, size: "1x" }), _jsx(Inline, { size: "small" }), t('button.remove')] })));
};
export default PaymentMethodRemoveButton;
